import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SlideCart from "components/slide-cart";
import BreadCrumbs from "components/breadcrumb";
import CookieConsent from "components/cookie-consent";
import CountryDetector from "components/country-detector";
import ToastContainer from "components/toast-container";
import SubscriptionCart from "components/subscription-cart";
import useURLToCart from "hooks/useURLToCart";
import { fetchCustomerOrders, getCustomerProfile } from "actions/account/profile";
import StickyBar from "components/sticky-bar";
import { getOrRefreshCustomerToken } from "actions/account/auth";
import { fetchCart, updateActiveBox } from "actions/cart";
import { fetchSubscriptions, fetchSubscriptionById } from "actions/account/subscription";
import HeaderWrapper from "components/header";
import FooterWrapper from "components/footer";
import { useGlobalContext } from "context/global";
import ReschedulingFlow from "components/rescheduling-flow";
import GorgiasChat from "components/gorgias-chat";
import ReactivationBanner from "components/reactivation-banner";
import { setupGlobalData } from "actions/global";
import SaveChangesPopup from "components/save-changes/popup";

const BaseLayout = (props) => {
	const { children, path, _type, pageSettings, header, footer, breadcrumbs, title } = props;
	const { totalProgress, checkoutUrl } = useSelector(state => state.cart);
	const { orders, id } = useSelector(state => state.account.profile);
	const { subscriptionId, showSaveChangesPopup, redirectPath } = useSelector(state => state.account.subscription);
	const dispatch = useDispatch();
	const hasProductSingle = children?.props?.modules?.some((mod) => mod._type === "productSingle");
	const { cartSettings, translation, langCode, subscriptionRules: { commitmentBasedDiscounts }, isOneTimeCollection } = useGlobalContext();
	const subscriptionDiscount = cartSettings.subscription.discountCode;

	useURLToCart();

	useEffect(() => {
		getOrRefreshCustomerToken().then(() => {
			dispatch(getCustomerProfile());
		});

		!checkoutUrl && dispatch(fetchCart(subscriptionDiscount));

		dispatch(setupGlobalData(cartSettings, commitmentBasedDiscounts, isOneTimeCollection));
	}, []);

	useEffect(() => {
		dispatch(updateActiveBox(cartSettings?.boxes, cartSettings?.subscription?.frequencies));
	}, [totalProgress]);

	useEffect(() => {
		if (!id) return;

		if (!subscriptionId)
			dispatch(fetchSubscriptions()).then((response) => {
				// Some data are not available in list of subscriptions so we need to fetch subscription by id
				dispatch(fetchSubscriptionById(response.id));
			});

		if (!orders.data.length)
			dispatch(fetchCustomerOrders());
	}, [id]);

	return (
		<>
			{header && <HeaderWrapper pageSettings={{ ...pageSettings, path }} context={header} />}
			{!pageSettings?.hideBreadcrumbs &&
				<BreadCrumbs
					crumbs={breadcrumbs} path={path} title={title} showSearch={_type === "collection"}
					productTranslation={translation.product}
				/>}
			{children}
			<ToastContainer />
			<SlideCart />
			<StickyBar data={pageSettings?.stickyBar} />
			<SubscriptionCart path={path} />
			{footer && <FooterWrapper pageSettings={pageSettings} context={footer} />}
			<GorgiasChat pageType={_type} hasProductSingle={hasProductSingle} path={path} />
			<CookieConsent current_lang={langCode} />
			<CountryDetector />
			<ReschedulingFlow />
			<ReactivationBanner />
			{subscriptionId && <SaveChangesPopup isOpen={showSaveChangesPopup} redirectPath={redirectPath} />}
		</>
	);
};

export default BaseLayout;
